import React, { useEffect, useState } from "react";
import clsx from "clsx";
import { useHistory } from "react-router";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {faCircleCheck, faCircleQuestion} from "@fortawesome/free-solid-svg-icons";
import _ from "lodash";
import { Col, Container, Row } from "react-bootstrap";
import * as axiosInstance from "../../../services/axiosInstance";
import * as fpxSelectors from "../../../selectors/fpx";
import CustomEmptyFont from "../../../components/CustomEmptyFont";
import LoadingOverlay from "../../../components/LoadingOverlay";
import PAGE from "../../../utils/Destination";
import {useSelector} from "react-redux";
import * as userSelelectors from "../../../selectors/user";

function PaymentSuccessful({}) {
    const history = useHistory();
    const search = history?.location?.search;
    const id = new URLSearchParams(search).get("payment_id");
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState(null);
    const profile = useSelector((state) => state?.user);

    useEffect(() => {
        if (!_.isEmpty(id)) {
            getFpxDetail();
        }
    }, [id]);

    const getFpxDetail = async () => {
        setLoading(true)
        try {
            const response = await axiosInstance.get(`clientarea/fpx/${id}`);
            if (response.code === 200) {
                setData(response.data);
            }
        } catch (e) {
        } finally {
            setLoading(false)

        }
    };

    const handleBack = (e) => {
        e.preventDefault()
        history.push(`${PAGE.PAYMENT_HISTORY}`);
    };

    const onClickPrint = () => {
        const reference = fpxSelectors.getFpxReference(data);
        const originalTitle = document.title;
        document.title = reference;
        window.print();
        document.title = originalTitle;
    };

    const getFpxResultContent = (data) => {
        const bank = fpxSelectors.getFpxBank(data);
        const gatewayTransactionID = fpxSelectors.getFpxGatewayTransactionID(data);
        const paidAt = fpxSelectors.getFpxPaidAt(data);
        const reference = fpxSelectors.getFpxReference(data);
        const paidAmount = fpxSelectors.getFpxPaidAmount(data);
        const status = fpxSelectors.getFpxStatus(data);
        const clientName = fpxSelectors.getFpxClientName(data);

        return (
            <>
                <div className={clsx("payment-card-title")}>
                    <h2>Pay with</h2>
                    <img src="/img/fpx-logo-2.png" className="payment-card-fpx-image"></img>
                </div>
                <div className={clsx("payment-card-title")}>
                    <h2>(Current and Savings Account) </h2>
                </div>
                <div className={clsx("payment-card-title mt-2")}>
                    <FontAwesomeIcon icon={faCircleCheck} className="fa-3x" color={status === 'paid' ? '#049F0C' : "#EE2D20"} />
                    <span className={clsx( status === 'paid' ? 'payment-success-span' : 'payment-unsuccess-span')}>Payment {status === 'paid' ? 'Successful' : "Unsuccessful"}</span>
                </div>
                <Row className="justify-content-center p-3 gy-1">
                    <Col xxl={6} xs={6}>
                        Date
                    </Col>
                    <Col xxl={6} xs={6}>
                        <CustomEmptyFont variant="span" prefix=":" value={paidAt} />
                    </Col>
                    <Col xxl={6} xs={6}>
                        Pay To
                    </Col>
                    <Col xxl={6} xs={6}>
                        <CustomEmptyFont variant="span" prefix=":" value={clientName} />
                    </Col>
                    <Col xxl={6} xs={6}>
                        Bank
                    </Col>
                    <Col xxl={6} xs={6}>
                        <CustomEmptyFont variant="span" prefix=":" value={bank} />
                    </Col>
                    <Col xxl={6} xs={6}>
                        Amount
                    </Col>
                    <Col xxl={6} xs={6}>
                        <CustomEmptyFont variant="span" prefix=":" value={paidAmount} />
                    </Col>
                    <Col xxl={6} xs={6}>
                        Reference NO
                    </Col>
                    <Col xxl={6} xs={6}>
                        <CustomEmptyFont variant="span" prefix=":" value={reference} />
                    </Col>
                    <Col xxl={6} xs={6}>
                        FPX Transaction ID
                    </Col>
                    <Col xxl={6} xs={6}>
                        <CustomEmptyFont variant="span" prefix=":" value={gatewayTransactionID} />
                    </Col>
                </Row>
                <div className="d-flex justify-content-center pt-3">
                    <button className={clsx("btn btn-primary-outline")} type="submit" onClick={handleBack}>
                        Back
                    </button>
                    <button
                        className={clsx("btn custom-button-primary ms-3")}
                        type="submit"
                        onClick={onClickPrint}
                        style={{ backgroundColor: "#9D7905" }}
                    >
                        Print
                    </button>
                </div>
                <div className={clsx("payment-card-title mt-3 justify-content-end w-100")}>
                    <h6>Powered By</h6>
                    <img src="/img/fpx-logo-2.png" className="payment-card-watermark-image"></img>
                </div>
            </>
        )
    }

    const clientCode = userSelelectors.getUserClientClientCode(profile);
    const clientName = userSelelectors.getUserClientClientName(profile);

    return (
        <Container className={clsx("payment-callback-container")}>
            {
                !_.isEmpty(data) ? (
                    <div className={clsx("printable-area")}>
                        <div className={clsx("d-flex flex-row justify-content-between align-items-center p-3 mt-2 text-muted text-small")}>
                            <span>{clientCode} / {clientName}</span>
                            <span>{ new Intl.DateTimeFormat('en-GB', {
                                day: '2-digit',
                                month: '2-digit',
                                year: 'numeric',
                                hour: '2-digit',
                                minute: '2-digit',
                                hour12: true,
                            }).format() }</span>
                        </div>
                        <div className={clsx("d-flex flex-column justify-content-center align-items-center p-5 border-top")}>
                            {getFpxResultContent(data)}
                        </div>
                    </div>
                ) : false
            }
            <Row className="justify-content-center payment-callback-card-container">
                <Col xxl={8} lg={10} md={10} xs={12}>
                    <div className="card p-3 payment-callback-card-item-container" style={{ minHeight: "50vh" }}>
                        {!_.isEmpty(data) ? (
                            getFpxResultContent(data)
                        ) : loading ? (
                            <LoadingOverlay loading={loading}></LoadingOverlay>
                        ) : (
                            <>
                                <FontAwesomeIcon className='fa-3x' icon={faCircleQuestion}></FontAwesomeIcon>
                                <p className="mt-2">Payment Not Found</p>
                                <div className="d-flex justify-content-center mt-1">
                                    <button
                                        style={{ backgroundColor: "#9D7905" }}
                                        className={clsx("btn custom-button-primary")}
                                        type="submit"
                                        onClick={getFpxDetail}
                                    >
                                        Refresh
                                    </button>
                                </div>
                            </>
                        )}
                    </div>
                </Col>
            </Row>
        </Container>
    );
}
export default PaymentSuccessful;
